export const numericValue = (stringValue, decimals = 0) => {
    if (typeof stringValue == 'number') {
        if (decimals > 0) {
            return stringValue.toFixed(decimals);
        } else {
            return stringValue;
        }
    }

    if (!stringValue) {
        return 0;
    }
    let value = stringValue.replace('$', '');
    value = value.replaceAll(',', '');

    let multiplier = 1;

    if (value.match(/B$/)) {
        multiplier = 1000000000;
    }
    if (value.match(/M$/)) {
        multiplier = 1000000;
    }
    if (decimals > 0) {
        return (parseFloat(value) * multiplier).toFixed(decimals);
    }

    return parseInt(value) * multiplier;
};

export const formatMilBillion = (amt) => {
    let amount = numericValue(amt);

    if (amount >= 1000) {
        let temp = amount / 1000;

        return '$' + temp.toString() + 'B';
    }

    return '$' + amount.toString() + 'M';
};

export const percentDecimal = (p) => {
    p = parseFloat(p);

    if (p > 0) {
        return p / 100;
    }

    return p;
};

export const formatMoney = (amount) => {
    if (isNaN(amount)) {
        return '';
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
    });

    return formatter.format(amount);
};
